import React from 'react';
import { Button, useTheme } from '@mui/material';
import PanelAlert from '../../../shared/components/PanelAlert';

/**
 * Browser Panel Alert Component
 * Shows the current tree selection or instructions
 */
const BrowserPanelAlert = ({ treeSelection, filteredCount, selectedCount, totalCount, onClearFilter, ...props }) => {
  const theme = useTheme();

  const getPrimaryMessage = () => {
    // Handle array of selections (mixed projects, targets, batches)
    if (treeSelection && treeSelection.length > 0) {
      if (treeSelection.length === 1) {
        // Single selection
        return treeSelection[0].split('::').slice(1).join(' > ');
      } else {
        // Multiple selections - categorize by type
        const projectCount = treeSelection.filter(id => id.startsWith('project::')).length;
        const targetCount = treeSelection.filter(id => id.startsWith('target::')).length;
        const batchCount = treeSelection.filter(id => id.startsWith('batch::')).length;

        const parts = [];
        if (projectCount > 0) {
          parts.push(`${projectCount} project${projectCount !== 1 ? 's' : ''}`);
        }
        if (targetCount > 0) {
          parts.push(`${targetCount} target${targetCount !== 1 ? 's' : ''}`);
        }
        if (batchCount > 0) {
          parts.push(`${batchCount} batch${batchCount !== 1 ? 'es' : ''}`);
        }

        if (parts.length === 0) {
          return `${treeSelection.length} items selected`;
        } else if (parts.length === 1) {
          return `${parts[0]} selected`;
        } else {
          return `${parts.join(', ')} selected`;
        }
      }
    }
    return 'Use the tree below to browse and filter files';
  };

  const getSecondaryMessage = () => {
    if (treeSelection && treeSelection.length > 0 && filteredCount !== undefined) {
      return `${filteredCount} file${filteredCount !== 1 ? 's' : ''} in selection`;
    }
    return 'Navigate through Projects → Targets → Batches';
  };

  return (
    <PanelAlert
      severity={treeSelection && treeSelection.length > 0 ? "info" : "warning"}
      primaryMessage={getPrimaryMessage()}
      secondaryMessage={getSecondaryMessage()}
      action={
        treeSelection && treeSelection.length > 0 && (
          <Button 
            size="small" 
            sx={{ 
              fontSize: theme.typography.fontSize.xs, 
              p: 0, 
              minWidth: 'auto', 
              textTransform: 'none',
              alignSelf: 'center',
              mr: theme.spacing(1)
            }}
            onClick={onClearFilter}
          >
            Clear
          </Button>
        )
      }
      sx={{
        mx: theme.spacing(2),
        mt: theme.spacing(2),
        mb: theme.spacing(1.5)
      }}
      {...props}
    />
  );
};

export default BrowserPanelAlert;